import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import { idlePeriod } from '@polymer/polymer/lib/utils/async.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { enqueueDebouncer } from '@polymer/polymer/lib/utils/flush.js';
import { usageStatistics } from '@vaadin/vaadin-usage-statistics/vaadin-usage-statistics.js';

if (!window.Vaadin) {
  window['Vaadin'] = {};
}
/**
 * Array of Vaadin custom element classes that have been finalized.
 */


window['Vaadin'].registrations = window.Vaadin.registrations || []; // Use the hack to prevent polymer-modulizer from converting to exports

window['Vaadin'].developmentModeCallback = window.Vaadin.developmentModeCallback || {};

window['Vaadin'].developmentModeCallback['vaadin-usage-statistics'] = function () {
  if (usageStatistics) {
    usageStatistics();
  }
};

var statsJob;
/**
 * @polymerMixin
 */

export var ElementMixin = function ElementMixin(superClass) {
  return (
    /*#__PURE__*/
    function (_superClass) {
      _inherits(VaadinElementMixin, _superClass);

      function VaadinElementMixin() {
        _classCallCheck(this, VaadinElementMixin);

        return _possibleConstructorReturn(this, _getPrototypeOf(VaadinElementMixin).apply(this, arguments));
      }

      _createClass(VaadinElementMixin, [{
        key: "ready",
        value: function ready() {
          _get(_getPrototypeOf(VaadinElementMixin.prototype), "ready", this).call(this);

          if (document.doctype === null) {
            console.warn('Vaadin components require the "standards mode" declaration. Please add <!DOCTYPE html> to the HTML document.');
          }
        }
      }], [{
        key: "_finalizeClass",

        /** @protected */
        value: function _finalizeClass() {
          _get(_getPrototypeOf(VaadinElementMixin), "_finalizeClass", this).call(this); // Registers a class prototype for telemetry purposes.


          if (this.is) {
            window.Vaadin.registrations.push(this);

            if (window.Vaadin.developmentModeCallback) {
              statsJob = Debouncer.debounce(statsJob, idlePeriod, function () {
                window.Vaadin.developmentModeCallback['vaadin-usage-statistics']();
              });
              enqueueDebouncer(statsJob);
            }
          }
        }
      }]);

      return VaadinElementMixin;
    }(superClass)
  );
};